export enum ModalValidationType {
  AmountNotAllocated = "AmountNotAllocated",
  AmountUnderAllocated = "AmountUnderAllocated",
  AmountOverAllocated = "AmountOverAllocated"
}
